var map = {
	"./baby.jpg": 8889,
	"./babybauch.jpg": 8372,
	"./babygalerie.jpg": 9058,
	"./babygalerie_old.jpeg": 925,
	"./familie.jpg": 5227,
	"./hochzeit.jpg": 9926,
	"./lkh_logo.png": 6520,
	"./lkh_logo2.png": 9195,
	"./logo_sw.png": 6542,
	"./slide2.jpg": 9262,
	"./slide4.jpg": 8899,
	"./slide6.jpg": 9289,
	"./tiere.jpg": 7186,
	"./weiß.png": 570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;